/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as R from 'ramda'
import React, { useEffect, useRef, useState } from 'react'
import { Stack } from '@mui/material'
import { IMessage } from '@weblite/ts-action/message'
import { useGetPrevAndNextByType } from '$common/react-hooks/message'
import { useMessageByIid } from '$logic/message/react-hook'
import { ImageViewerModal } from '$comp/modals/image-viewer'
import { getAvailableFunctions } from '$logic/message'
import { useAsyncFunction } from '$func/async-function.react-hook'
import { VideoPlayerModal } from '$comp/modals/video-player'
import { MediaViewerLoader } from '$comp/modals/media-viewer/media-viewer-loader'

interface Props {
  roomId: string
  iid: number
}

const MediaViewerSelector: Record<'IMAGE' | 'VIDEO', any> = {
  IMAGE: ImageViewerModal,
  VIDEO: VideoPlayerModal,
}

export function MediaViewerModal({ roomId, iid: startIid }: Props) {
  const [iid, setIid] = useState(startIid)
  const iidRef = useRef(null)
  const { current, total, next, prev, loading } =
    useGetPrevAndNextByType(roomId, iidRef.current, 'MEDIA') || {}

  const prevRef = useRef(null)
  const nextRef = useRef(null)
  useEffect(() => {
    prevRef.current = prev
    nextRef.current = next
    iidRef.current = iid
  }, [prev, next, iid])
  const { message } = useMessageByIid(iid, roomId)
  const { value: functions } = useAsyncFunction(
    () => getAvailableFunctions(message as IMessage),
    [message],
  )

  const [tempState, setTempState] = useState({ current: null, total: null })

  useEffect(() => {
    if (current && total) setTempState({ total, current })
  }, [current, total])
  const onPrev = () => {
    if (!prevRef.current) return
    setIid(prevRef.current)

    setTempState({ total: tempState.total, current: tempState.current - 1 })
  }

  const onNext = () => {
    if (!nextRef.current) return
    setIid(nextRef.current)
    setTempState({ total: tempState.total, current: tempState.current + 1 })
  }

  // @ts-ignore
  const ViewerComponent = MediaViewerSelector[message?.type]
  return (
    <Stack sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {message?.type === 'IMAGE' || message?.type === 'VIDEO' ? (
        <ViewerComponent
          media={{
            owner: message.sender,
            date: message.date,
            description: message.body,
            functions: R.dissoc('onEdit', functions),
            attachment: message.attachment,
            links: message.links,
          }}
          current={tempState.current}
          total={tempState.total}
          onPrev={onPrev}
          onNext={onNext}
          loading={loading}
        />
      ) : (
        <MediaViewerLoader
          current={tempState.current}
          total={tempState.total}
        />
      )}
    </Stack>
  )
}
